import React, { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { PRODUCTS } from "../../constants/products";
import ProductCard from "./product-card";
import WorkingCapitalRegistrationForm from "./working-capital-registration-form";
import WorkingCapitalError from "./working-capital-error";
import { ENV } from "../../config/env";
import { useSelector } from "react-redux";
import { RootState } from "../../reducers";
import { useDispatch } from "react-redux";
import { setForm } from "../../reducers/formslice";

function ProductModal() {
  const dispatch = useDispatch();
  const { form } = useSelector((state: RootState) => state.form);
  const [registerCapitalLoan, setRegisterCapitalLoan] = useState(false);
  const [failedCapitalLoan, setFailedCapitalLoan] = useState(false);

  const onHide = () => {
    dispatch(setForm(null));
  };
  const handleHide = () => {
    if (ENV.V2_PRODUCTS.includes("capitalLoan")) {
      onHide();
      return;
    }
    if (failedCapitalLoan) {
      onHide();
      return;
    }
    if (registerCapitalLoan) {
      setRegisterCapitalLoan(false);
      return;
    }
    onHide();
  };

  const handleLogin = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    onHide();
    dispatch(setForm("login"));
  };

  return (
    <React.Fragment>
      <Modal
        show={form === "register"}
        onHide={handleHide}
        size={registerCapitalLoan ? (failedCapitalLoan ? "xl" : "lg") : "xl"}
      >
        <Modal.Header closeButton>
          {failedCapitalLoan ? (
            <Modal.Title className="text-center fw-bold text-danger">
              Registrasi anda tidak dapat dilanjutkan!
            </Modal.Title>
          ) : (
            <Modal.Title
              className={
                registerCapitalLoan ? "text-center fw-bold" : "text-center"
              }
            >
              {registerCapitalLoan
                ? `Registrasi ${PRODUCTS.capitalLoan.title}`
                : "Pilih jenis pinjaman yang sesuai"}
            </Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          {failedCapitalLoan ? (
            <WorkingCapitalError onClose={onHide} />
          ) : registerCapitalLoan ? (
            <WorkingCapitalRegistrationForm
              onCancel={handleHide}
              onFinish={onHide}
              onFailed={() => setFailedCapitalLoan(true)}
            />
          ) : (
            <React.Fragment>
              <Row>
                {Object.keys(PRODUCTS).map((p) => {
                  const productInfo = PRODUCTS[p];
                  return (
                    <Col key={p} lg={6} md={12} sm={12} xs={12} className="p-2">
                      <ProductCard
                        product={productInfo}
                        onRegisterCapitalLoan={() => {
                          if (!ENV.V2_PRODUCTS.includes("capitalLoan")) {
                            setRegisterCapitalLoan(true);
                          }
                        }}
                        onNavigate={onHide}
                      />
                    </Col>
                  );
                })}
              </Row>
              <div className="mt-5 text-center text-size-sub-body-2">
                Sudah punya akun?{" "}
                <a href={"/"} rel="noreferrer" onClick={handleLogin}>
                  Masuk di sini
                </a>
              </div>
            </React.Fragment>
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

export default ProductModal;
